module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my",
    attrs: {
      "id": ("category-" + _vm.id)
    }
  }, [_vm._l((_vm.subjects), function(subject) {
    return _c('div', {
      key: subject.id,
      staticClass: "my__anchor-point",
      attrs: {
        "id": ("a" + (subject.id))
      }
    })
  }), _vm._v(" "), _c('h2', {
    staticClass: "my__name mdTtl02"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.id === '4') ? _c('p', {
    staticClass: "my__judgement-notes"
  }, [_vm._v("英語以外の外国語に得点を入力した場合は、「英語（リスニング）」の得点は入力できません。「英語（リスニング）テスト受験免除者」は、「英語（リーディング）」と同じ点数を「英語（リスニング）」に入力してください。")]) : _vm._e(), _vm._v(" "), (_vm.id === '8') ? _c('p', {
    staticClass: "my__judgement-notes"
  }, [_vm._v("「簿記・会計」「情報関係基礎」に得点を入力した場合は「数IIＢ」として自動的に集計し、合格可能性を判定します。")]) : _vm._e(), _vm._v(" "), (_vm.subjects.length) ? _c('div', {
    staticClass: "my__subjects",
    attrs: {
      "id": ("subjects-" + _vm.id)
    }
  }, _vm._l((_vm.subjects), function(subject) {
    return _c('my-subject', {
      key: subject.id,
      ref: "subjects",
      refInFor: true,
      staticClass: "my__subject",
      attrs: {
        "id": subject.id
      },
      on: {
        "change-state": function($event) {
          _vm.onChangeSubjectState(subject, $event)
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.firstChoiceSelectable) ? _c('div', {
    staticClass: "my__first-subject"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstChoice),
      expression: "firstChoice"
    }],
    staticClass: "my__first-subject__select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.firstChoice = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.name) + "受験なし")]), _vm._v(" "), _vm._l((_vm.firstChoiceSubjects), function(subject) {
    return (subject.fixed) ? _c('option', {
      key: subject.id,
      domProps: {
        "value": subject.id
      }
    }, [_vm._v(_vm._s(subject.name))]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "my__first-subject__guide"
  }, [_vm._v("\n      " + _vm._s(_vm.name) + "の第1解答科目を選択してください。\n    ")])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b1ccfce","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/jikosaiten/index/components/Category.vue
// module id = 917
// module chunks = 3